// extracted by mini-css-extract-plugin
module.exports = {"printersAndScalesTabs":"PrintersAndScalesTabs_printersAndScalesTabs__2YDV7","printersAndScalesTabsContainer":"PrintersAndScalesTabs_printersAndScalesTabsContainer__3nzgD"};